"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerRowPromoteScopeActions = exports.createRowPromoteScopeActions = void 0;
var outlineTaskPromote_1 = require("./outlineTaskPromote");
var rowSplitScopeActions_1 = require("./rowSplitScopeActions");
function parentFkOf(row) {
    var _a, _b;
    if (!row)
        return 0;
    var raw = (_b = (_a = (row.edit && row.edit.pnParentFK != null ? row.edit.pnParentFK : null)) !== null && _a !== void 0 ? _a : row.pnParentFK) !== null && _b !== void 0 ? _b : 0;
    var n = Number(raw);
    return Number.isFinite(n) && n > 0 ? n : 0;
}
function refreshAfterHierarchy(host, context) {
    var _a, _b;
    try {
        if (context === 'search')
            host.reloadSearch();
        else if (context === 'recent') {
            host.fetchRecent();
            host.reloadFocus();
        }
        else if (context === 'focus')
            host.reloadFocus();
        else {
            (_a = host.fetchRecent) === null || _a === void 0 ? void 0 : _a.call(host);
            (_b = host.reloadSearch) === null || _b === void 0 ? void 0 : _b.call(host);
        }
    }
    catch (_c) {
        /* ignore */
    }
}
function createRowPromoteScopeActions(host, pilotNotesSyncService) {
    function runPromote(row, parentKind, context) {
        var _a, _b;
        if (!row || !row.ID)
            return;
        var body = (_b = (_a = (row.edit && row.edit.pnBody != null ? row.edit.pnBody : null)) !== null && _a !== void 0 ? _a : row.pnBody) !== null && _b !== void 0 ? _b : '';
        if (!String(body).trim()) {
            host.toast('Nothing to promote — body is empty.', 'info', 3000);
            return;
        }
        (0, rowSplitScopeActions_1.saveChangesAndProceed)(host, row, function () {
            var caption = (0, outlineTaskPromote_1.firstLineCaption)(String(body));
            pilotNotesSyncService
                .promoteTNotes(Number(row.ID), {
                parentKind: parentKind,
                caption: caption,
                stubTBody: true,
            })
                .then(function (data) {
                var docId = data.documentId || data.document_id;
                host.toast(parentKind === 'task'
                    ? "Created task parent #".concat(docId, "; Actual re-parented under it.")
                    : "Created document #".concat(docId, "; notes moved off Actual."), 'success', 5000);
                // Local patch so open edit reflects light T under I
                try {
                    var actual = data.actual;
                    if (actual) {
                        if (actual.body !== undefined)
                            row.pnBody = actual.body;
                        if (actual.parent_id !== undefined)
                            row.pnParentFK = actual.parent_id;
                    }
                    else {
                        row.pnBody = caption;
                        if (docId)
                            row.pnParentFK = docId;
                    }
                    if (row.edit) {
                        row.edit.pnBody = row.pnBody;
                        if (row.pnParentFK != null)
                            row.edit.pnParentFK = row.pnParentFK;
                    }
                }
                catch (_a) {
                    /* ignore */
                }
                refreshAfterHierarchy(host, context);
                // Open the new document for further outline task work
                if (docId && typeof host.personSearch === 'function') {
                    try {
                        host.personSearch({ pnid: docId });
                    }
                    catch (_b) {
                        /* ignore */
                    }
                }
            }, function (err) {
                host.toast("Promote failed: ".concat((err && err.message) || err || 'Error'), 'danger', 6000);
            });
        });
    }
    return {
        canPromoteTNotes: function (row) {
            var _a, _b;
            var body = (_b = (_a = (row && row.edit && row.edit.pnBody != null ? row.edit.pnBody : null)) !== null && _a !== void 0 ? _a : (row && row.pnBody)) !== null && _b !== void 0 ? _b : '';
            return (0, outlineTaskPromote_1.canPromoteTNotes)({
                ID: row && row.ID,
                pnBody: body,
                pnTaskGroup: row && row.pnTaskGroup,
                pnTopicGroup: row && row.pnTopicGroup,
                pnFlowKind: row && row.pnFlowKind,
            });
        },
        promoteTNotesToDocument: function (row, context) { return runPromote(row, 'document', context); },
        promoteTNotesToTask: function (row, context) { return runPromote(row, 'task', context); },
        canMoveUpParent: function (row) {
            if (!row || row.ID == null || row.ID === '')
                return false;
            return parentFkOf(row) > 0;
        },
        moveUpParent: function (row, context) {
            if (!row || !row.ID)
                return;
            if (parentFkOf(row) <= 0) {
                host.toast('Already top-level — nothing to move up.', 'info', 3000);
                return;
            }
            (0, rowSplitScopeActions_1.saveChangesAndProceed)(host, row, function () {
                pilotNotesSyncService.moveUpParent(Number(row.ID)).then(function (data) {
                    var _a, _b;
                    var newParent = data.parentId !== undefined
                        ? data.parentId
                        : data.parent_id !== undefined
                            ? data.parent_id
                            : null;
                    var prev = (_b = (_a = data.previousParentId) !== null && _a !== void 0 ? _a : data.previous_parent_id) !== null && _b !== void 0 ? _b : parentFkOf(row);
                    host.toast(newParent
                        ? "Moved #".concat(row.ID, " up under #").concat(newParent, " (was under #").concat(prev, ").")
                        : "Moved #".concat(row.ID, " up to top level (was under #").concat(prev, ")."), 'success', 5000);
                    try {
                        row.pnParentFK = newParent;
                        if (row.edit)
                            row.edit.pnParentFK = newParent;
                        var ser = data.row;
                        if (ser && ser.parent_id !== undefined) {
                            row.pnParentFK = ser.parent_id;
                            if (row.edit)
                                row.edit.pnParentFK = ser.parent_id;
                        }
                    }
                    catch (_c) {
                        /* ignore */
                    }
                    refreshAfterHierarchy(host, context);
                }, function (err) {
                    host.toast("Move up failed: ".concat((err && err.message) || err || 'Error'), 'danger', 6000);
                });
            });
        },
    };
}
exports.createRowPromoteScopeActions = createRowPromoteScopeActions;
function registerRowPromoteScopeActions($scope, pilotNotesSyncService) {
    var actions = createRowPromoteScopeActions($scope, pilotNotesSyncService);
    $scope.canPromoteTNotes = actions.canPromoteTNotes;
    $scope.promoteTNotesToDocument = actions.promoteTNotesToDocument;
    $scope.promoteTNotesToTask = actions.promoteTNotesToTask;
    $scope.canMoveUpParent = actions.canMoveUpParent;
    $scope.moveUpParent = actions.moveUpParent;
}
exports.registerRowPromoteScopeActions = registerRowPromoteScopeActions;
